var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8391 21.7636V30.7178L24.9305 36.4681L15.0179 30.7178V19.2173L24.9345 13.459L32.5494 17.882L33.7003 17.2163L24.9345 12.1277L13.8711 18.5476V31.3834L24.9345 37.8034L35.998 31.3834V21.0979L34.8391 21.7636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1581 30.7261H20.502V25.1362H26.0277C26.549 25.1322 27.0502 24.9197 27.4191 24.5428C27.788 24.1698 27.9925 23.6646 27.9965 23.1393C28.0006 22.8786 27.9484 22.622 27.8482 22.3814C27.7479 22.1408 27.5996 21.9243 27.4151 21.7438C27.2347 21.5594 27.0181 21.411 26.7815 21.3107C26.5449 21.2105 26.2883 21.1584 26.0277 21.1624H20.502V19.4622H26.0317C26.9981 19.4662 27.9284 19.8591 28.6101 20.5448C29.2958 21.2346 29.6807 22.1649 29.6887 23.1393C29.6927 23.8851 29.4682 24.6109 29.0431 25.2204C28.6502 25.8019 28.0968 26.259 27.4512 26.5317C26.8096 26.7362 26.1439 26.8364 25.4743 26.8324H22.1581V30.7261Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6471 30.5854H27.7144L26.2227 27.9709C26.8121 27.9348 27.3936 27.8145 27.9509 27.614L29.6471 30.5854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6836 19.9032L34.8264 20.5408L35.9693 19.9032V18.5519L34.8264 17.8862L33.6836 18.5519V19.9032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRd);
export default __webpack_public_path__ + "static/media/rd.53f292e59ec124efe54eebcb081c3528.svg";
export { ForwardRef as ReactComponent };